// extracted by css-extract-rspack-plugin
var _1 = "QRAH3c4SXksYdXIl";
export { _1 as "summary" }
// extracted by css-extract-rspack-plugin
var _1 = "QRAH3c4SXksYdXIl";
export { _1 as "summary" }
